module.exports = __webpack_public_path__ + "img/light_off.f11ae76c.png";